import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { resolveUrl, API_PREFIX } from 'src/core/constants/api.constants';

const WRAP_UP_DEFINITION = `${API_PREFIX}/wrap-up-definition`;

@Injectable({
  providedIn: 'root',
})
export class WrapUpDefinitionService {
  private readonly http = inject(HttpClient);

  checkNameUnique(name: string, excludedId?: number): Observable<boolean> {
    const params = new HttpParams()
      .set('name', name)
      .set('excludedId', String(excludedId ?? 0));

    return this.http
      .get<boolean | { data?: boolean }>(
        resolveUrl(`${WRAP_UP_DEFINITION}/check-name-unique`),
        { params },
      )
      .pipe(
        map(response => {
          if (typeof response === 'boolean') {
            return response;
          }

          if (typeof response?.data === 'boolean') {
            return response.data;
          }

          return false;
        }),
      );
  }
}
